import { createEffect } from 'effector'
import { getShareLink } from './api'

export const getShareLinkFx = createEffect(async (token: string) => {
  const data = await getShareLink(token)
  return data
})

getShareLinkFx.failData.watch(() => {
  console.log('oops, we could not get share link')
})
